import { Button, message, Modal, Space, Tag, Typography } from "antd"
import { useCallback, useEffect, useState } from "react"
import NavRouteViewer from "../../../../components/common/nav.route.viewer"
import { AmapNaviationPath, Location, MapPathSaveArgsType } from "../../../../constants/serve"
import Requestor from "../../../../requestor"

type IProps = {
  sid: string
  itemId: number
  item: number
  title?: string
  starting?: Location
  destination?: Location
  distance: number//距离
}
type NavRouteType = MapPathSaveArgsType & { id: string }
const LocationPathViewer = (props: IProps) => {
  const [navRoutes, setNavRoutes] = useState<NavRouteType | undefined>(undefined)
  const [LngLats, setLngLats] = useState<AMap.LngLatLike[][]>([])
  const [showNav, setShowNav] = useState(false)

  const getLocations = useCallback(async (sid: string, itemId: number, item: number) => {

    try {
      let res = await Requestor.getNavigationRoutes<NavRouteType>(sid, itemId, item).then(res => { return res })
      if (res.error !== "") {
        throw res.error
      }

      if (res.result) {
        setNavRoutes(res.result)
      }

    } catch (error) {
      console.log("报错：", error);
    }
  }, [])

  useEffect(() => {

    if (!navRoutes) return

    try {
      let selected: AmapNaviationPath = JSON.parse(navRoutes.routesJsonSelected)
      let _laglngs: AMap.LngLatLike[][] = []

      selected.steps.map(step => {
        let points = step.polyline.split(";")
        let _laglng = points.map(p => {
          let latlngstr = p.split(",")
          let latlng: AMap.LngLatLike = [parseFloat(latlngstr[0]), parseFloat(latlngstr[1])]
          return latlng
        })
        _laglngs = _laglngs.concat(_laglng)
        return _laglng
      })

      setLngLats(_laglngs)

    } catch (error) {
      console.log(error)
    }

  }, [navRoutes])

  useEffect(() => {
    getLocations(props.sid, props.itemId, props.item)
  }, [props.sid, props.itemId, props.item, getLocations])


  return <div style={{ display: "inline-block" }}>
    <Button onClick={() => { if (!navRoutes) { message.warning("该服务没有导航信息"); } setShowNav(true); }}>{props.title}</Button>
    <Modal
      title="服务导航路径"
      width={"50%"}
      open={showNav}
      onCancel={setShowNav.bind(this, false)}
      footer={null}
      destroyOnClose
    >
      {LngLats.length < 1 && !navRoutes && <Tag color="orange">该服务没有导航信息</Tag>}
      {props.distance && <div> <Typography.Text strong>距离：</Typography.Text> {Math.ceil(props.distance / 1000)}公里</div>}
      <Space size={30} style={{ marginBottom: "8px" }}>
        {props.starting && <div> <Typography.Text strong>起始地</Typography.Text> {(props.starting.address + props.starting.name)}</div>}
        {props.destination && <div><Typography.Text strong>送达地</Typography.Text> {(props.destination.address + props.destination.name)}</div>}
      </Space>
      <NavRouteViewer paths={LngLats}></NavRouteViewer>
    </Modal>
  </div>
}

export default LocationPathViewer
